import cn from './form.module.css';

interface ItemFormBlockProps {
  title: string;
  children: React.JSX.Element;
}

const ItemFormBlock = ({ title, children }: ItemFormBlockProps) => (
  <div className={cn.itemFormBlock}>
    <div className={cn.itemFormBlockTitle}>{title}</div>
    {children}
  </div>
);

export default ItemFormBlock;
